export default __webpack_public_path__ + "static/media/nillkin-case-1.60dec4fb.jpg";